import React, { useEffect, useState, useCallback } from "react";
import {
  Container,
  Typography,
  Card,
  CardContent,
  Grid,
  CircularProgress,
  AppBar,
  Toolbar,
  Button,
  Icon,
} from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";
import TopNavBar from "../components/TopNavBar";
import { useNavigate } from "react-router-dom";

export default function UserManagementPage() {
  const username = sessionStorage.getItem("username");
  const navigate = useNavigate();
  const goToRegisterUser = () => navigate("/register-user");

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  return (
    <>
      <TopNavBar
        title="Robot Cleaner Dashboard"
        username={username}
        heading={"User Management"}
      />
      <Container sx={{ mt: 4 }}>
        <Typography variant="h5" gutterBottom>
          TO DO
        </Typography>
        <Typography variant="h5" gutterBottom>
          - Search users
        </Typography>
        <Typography variant="h5" gutterBottom>
          - Edit user rights
        </Typography>
        <Typography variant="h5" gutterBottom>
          - Deactivate a user
        </Typography>
        <Typography variant="h5" gutterBottom>
          - Show currently logged in users
        </Typography>
        <Button onClick={goToRegisterUser}>Register a new user</Button>
      </Container>
    </>
  );
}
